import { render, staticRenderFns } from "./ResultInformation.vue?vue&type=template&id=142fd61e&lang=pug&"
import script from "./ResultInformation.vue?vue&type=script&lang=js&"
export * from "./ResultInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports